import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { trackingURL } from '@xingternal/xing-tracking';
import { IconSearch } from '@xingternal/icons';
import { trackings } from '../../../tracking';
import { Item } from '../Item';
import { Section } from './components';
const formatTitle = ({ keywords, location }, formatMessage) => {
    const { city, text, radius } = location || {};
    const cityText = (city && city.name) || text || '';
    const radiusText = cityText && radius ? ` / ${radius}km` : '';
    const locationText = `${cityText}${radiusText}`;
    if (!keywords) {
        // TODO: Temporary solution until we can work on https://jira.xing.hh/browse/JOBS3-843
        // The second expression in the ternary operator deals with a search with only filters (no keywords and no location)
        // We can remove it once we are able to translate the filters
        // Remember also to remove the `malt-core` tag from the `JOB_SEARCH_ALERTS_ALERT_NAME_ALL` Phrase key
        return locationText
            ? formatMessage({ id: 'SE_JOBS_SUGGESTED_NAME_LOCATION' }, { location: locationText })
            : formatMessage({ id: 'JOB_SEARCH_ALERTS_ALERT_NAME_ALL' });
    }
    return `${keywords}${locationText ? ` + ${locationText}` : ''}`;
};
function RecentSearchesSection({ baseI, highlightedIndex, section: { title, items }, getItemProps, userId, intl: { formatMessage }, }) {
    // clean up items with jobSearchQuery: null
    const filteredItems = items.filter((el) => el.jobSearchQuery);
    return (React.createElement(Section, { type: "recent-searches", headline: title }, filteredItems.map(({ trackingToken, payload: { url, ...payload }, jobSearchQuery }, i) => {
        const position = i + baseI;
        return (React.createElement(Item, { icon: React.createElement(IconSearch, { width: 24, height: 24 }), getItemProps: getItemProps, key: trackingToken, data: {
                ...payload,
                title: formatTitle(jobSearchQuery, formatMessage),
                url: trackingURL(url, 'query_result')(trackings),
                trackingToken,
                position,
                userId,
            }, isHighlighted: position === highlightedIndex }));
    })));
}
RecentSearchesSection.propTypes = {
    baseI: PropTypes.number.isRequired,
    highlightedIndex: PropTypes.number,
    getItemProps: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    section: PropTypes.shape({
        title: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape({
            jobSearchQuery: PropTypes.shape({
                keywords: PropTypes.string,
                location: PropTypes.shape({
                    city: PropTypes.shape({
                        name: PropTypes.string,
                    }),
                    text: PropTypes.string,
                    radius: PropTypes.number,
                }),
            }).isRequired,
            payload: PropTypes.shape({
                url: PropTypes.string.isRequired,
            }).isRequired,
            trackingToken: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
    intl: PropTypes.object.isRequired,
};
export default injectIntl(RecentSearchesSection);
//# sourceMappingURL=RecentSearches.js.map